// extracted by mini-css-extract-plugin
module.exports = {"commentsCustomScrollBar":"_3Ak_6","groupPopoverCommentsInner":"f6n2N","noComments":"_2Vp6B","addCommentButton":"n-SRg"};